"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageGalleryComponent = exports.ImageGalleryComponent = void 0;
const app_1 = require("app");
const Gallery_1 = require("Views/Partials/Components/Gallery/Gallery");
class ImageGalleryComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.image-gallery';
    }
    OnInit() {
        this.el.forEach((el, index) => {
            this.renderMediaGallery(el, index);
        });
    }
    renderMediaGallery(el, index) {
        (0, Gallery_1.RenderGallery)({
            galleryProperties: el.getAttribute('data-items'),
            uniqueClassName: `media-element-${index}`,
            playButtonAriaLabel: el.getAttribute('data-play-button-aria-label'),
            popupAriaLabel: el.getAttribute('data-popup-aria-label'),
            closeButtonAriaLabel: el.getAttribute('data-close-button-aria-label'),
            hideThumbnails: this.checkIsHideThumbnails(el.getAttribute('data-hide-thumbnails')),
            isMediaGallery: !!el.getAttribute('data-media-gallery'),
        }, el);
    }
    checkIsHideThumbnails(attr) {
        return !attr ? false : attr.toLowerCase() === 'true';
    }
}
exports.ImageGalleryComponent = ImageGalleryComponent;
exports.imageGalleryComponent = new ImageGalleryComponent();
